module.exports = __webpack_public_path__ + "static/projects-header-small.ced326c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects-header-small.jpg
// module id = 438
// module chunks = 202660965941462